import { BizAppConfig } from 'config/application.manifest';

export interface OrganizationMember {
  id: string;
  name: string;
  username?: string;
  phone?: string;
  email?: string;
  memberUuid?: string;
  organizationUuid?: string;
}

const normalizeOpenPlatformPath = (value: string) =>
  value.replace(/^\/+|\/+$/g, '');

const getOrganizationMemberUrl = (pageNo: number, pageSize: number) => {
  const serviceUrl = BizAppConfig.appOpenServiceUrl?.trim().replace(/\/+$/, '');
  const gatewayPath = normalizeOpenPlatformPath(
    BizAppConfig.appOpenApiGatewayPath?.trim() || '',
  );
  const categoryCode = normalizeOpenPlatformPath(
    BizAppConfig.appOrganizationAdminCategoryCode?.trim() || '',
  );
  if (!serviceUrl || !gatewayPath || !categoryCode) {
    throw new Error('开放平台成员目录配置不完整');
  }
  return `${serviceUrl}/${gatewayPath}/${categoryCode}/api/v1/members?pageNo=${pageNo}&pageSize=${pageSize}`;
};

export async function listOrganizationMembers(
  accessToken: string,
  memberUuid: string,
) {
  const pageSize = 100;
  let pageNo = 1;
  const members: OrganizationMember[] = [];

  while (true) {
    const response = await fetch(getOrganizationMemberUrl(pageNo, pageSize), {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${accessToken}`,
        memberUuid,
      },
    });
    if (!response.ok) {
      throw new Error(`成员目录加载失败 (${response.status})`);
    }

    const payload = (await response.json()) as {
      list?: Array<Record<string, unknown>>;
      total?: number;
    };
    const rawItems = payload.list || [];
    members.push(
      ...rawItems
        .map<OrganizationMember>((item) => {
          const id =
            typeof item.memberUuid === 'string'
              ? item.memberUuid.trim()
              : typeof item.id === 'string'
                ? item.id.trim()
                : '';
          const name =
            typeof item.name === 'string'
              ? item.name.trim()
              : typeof item.nickname === 'string'
                ? item.nickname.trim()
                : typeof item.username === 'string'
                  ? item.username.trim()
                  : '';
          return {
            id,
            memberUuid: id,
            name,
            username:
              typeof item.username === 'string'
                ? item.username.trim()
                : undefined,
            phone:
              typeof item.phone === 'string' ? item.phone.trim() : undefined,
            email:
              typeof item.email === 'string' ? item.email.trim() : undefined,
            organizationUuid:
              typeof item.organizationUuid === 'string'
                ? item.organizationUuid.trim()
                : undefined,
          };
        })
        .filter((item) => Boolean(item.id && item.name)),
    );

    const total = Number(payload.total || 0);
    if (
      !rawItems.length ||
      rawItems.length < pageSize ||
      pageNo * pageSize >= total
    ) {
      break;
    }
    pageNo += 1;
  }

  return members;
}
